import { Disclaimer, Div, Separator, lightTheme } from '@vgrubs/components';

/**
 * The part of a phone card under its header: a divider, then the desktop
 * columns as rows of PhoneCardLabel + value, the values lined up beside one
 * column of labels. Shared by both lists on this page.
 */
export const PhoneCardDetails = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <>
    <Separator $m="12px 0" />
    {/* A grid, not one flex line per value: the labels are not the same
        width, and only a shared column lines the values up. Baseline, so a
        label sits on the first line of a value that has more than one. */}
    <Div
      $grid
      $gridTemplateColumns="max-content minmax(0, 1fr)"
      $gap="8px 16px"
      style={{ alignItems: 'baseline' }}
    >
      {children}
    </Div>
  </>
);

/** A row's label in PhoneCardDetails, light grey so the values lead. */
export const PhoneCardLabel = ({ children }: { children: React.ReactNode }) => (
  <Disclaimer $m="0" $noWrap $color={lightTheme.lightGray}>
    {children}
  </Disclaimer>
);
